export default __webpack_public_path__ + "static/media/sp-1.6aa333ad.png";